module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hress5u-popup2",
      "id": "hress5u-popup2",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['0']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codjob",
      "name": "coddesc_codjob"
    }
  }, [_vm._v(_vm._s(_vm.popup2DetailTab2.tab1.codjob) + " - " + _vm._s(_vm.popup2DetailTab2.tab1.desc_codjob))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "accordion-tab2Popup2"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-tab2Popup2",
      "href": "#detailsPopup2Tab1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESS5UP1']['0']) + "\n\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "detailsPopup2Tab1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text txtarea-width width-100",
    attrs: {
      "id": "desc_codjob",
      "name": "desc_codjob"
    }
  }, [_vm._v(_vm._s(_vm.popup2DetailTab2.tab1.desc_codjob))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text txtarea-width width-100",
    attrs: {
      "id": "desjob",
      "name": "desjob"
    }
  }, [_vm._v(_vm._s(_vm.popup2DetailTab2.tab1.desjob))])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-left"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['60']))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popup2DetailTab2.tab1.amtcolla),
      expression: "popup2DetailTab2.tab1.amtcolla"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "amtcolla",
      "name": "amtcolla"
    },
    domProps: {
      "value": (_vm.popup2DetailTab2.tab1.amtcolla)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.popup2DetailTab2.tab1, "amtcolla", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['80']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popup2DetailTab2.tab1.qtyguar),
      expression: "popup2DetailTab2.tab1.qtyguar"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "qtyguar",
      "name": "qtyguar"
    },
    domProps: {
      "value": (_vm.popup2DetailTab2.tab1.qtyguar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.popup2DetailTab2.tab1, "qtyguar", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['100']))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popup2DetailTab2.tab1.qtyyrsur),
      expression: "popup2DetailTab2.tab1.qtyyrsur"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "disabled": "disabled",
      "id": "qtyyrsur",
      "name": "qtyyrsur"
    },
    domProps: {
      "value": (_vm.popup2DetailTab2.tab1.qtyyrsur)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.popup2DetailTab2.tab1, "qtyyrsur", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['120']))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-block-float detail-block-right"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UP1']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text txtarea-width width-100",
    attrs: {
      "id": "syncond",
      "name": "syncond"
    }
  }, [_vm._v(_vm._s(_vm.popup2DetailTab2.tab1.syncond))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-tab2Popup2",
      "href": "#detailsPopup2Tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESS5UP2']['0']) + "\n\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detailsPopup2Tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columnsDetailTab2Popup2Tab2,
      "data": _vm.popup2DetailTab2.tab2.table
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-tab2Popup2",
      "href": "#detailsPopup2Tab3"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESS5UP3']['0']) + "\n\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detailsPopup2Tab3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columnsDetailTab2Popup2Tab3,
      "data": _vm.popup2DetailTab2.tab3.table
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-tab2Popup2",
      "href": "#detailsPopup2Tab4"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESS5UP5']['0']) + "\n\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "detailsPopup2Tab4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columnsDetailTab2Popup2Tab4,
      "data": _vm.popup2DetailTab2.tab4.table
    }
  })], 1)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19608931!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hress5u/popup2.vue
// module id = 3598
// module chunks = 1